import { DataSyncSuccessDialog, fetchAuthConfigForDataSync } from './DataSync';
import { UnifiedAuthView } from './LowLevelUnifiedAuth';
import { DataSyncIntroScreen } from './DataSync';
import { getDataSyncScreens } from './DataSyncRegistry';
import { UniversalAuthTracker } from './UsageTracker';
import { createElement, Fragment } from 'react';
import './dataSyncRegistrations';
import { jsx as _jsx } from "react/jsx-runtime";
export function DataSyncAuthModal({
  portalId,
  appId,
  accountId,
  isModal = true,
  skipIntro = false,
  onComplete,
  onCancel,
  onOpenExternalLink,
  onSetupSyncClick,
  onDoThisLaterClick,
  trackingSource,
  introScreen,
  successScreen,
  onDuplicateAccountClick
}) {
  var _ref;
  const renderDefaultSuccessScreen = ({
    appName,
    authResponse
  }) => /*#__PURE__*/_jsx(DataSyncSuccessDialog, {
    appName: appName,
    onCancel: onCancel,
    portalId: portalId,
    appId: appId,
    authResponse: authResponse,
    onOpenExternalLink: onOpenExternalLink,
    onSetupSyncClick: onSetupSyncClick,
    onDoThisLaterClick: onDoThisLaterClick
  });
  const registryScreens = getDataSyncScreens(appId);
  // Returning null from the intro screen makes the flow start on the first real auth step.
  const resolvedIntroScreen = skipIntro ? () => null : (_ref = introScreen !== null && introScreen !== void 0 ? introScreen : registryScreens === null || registryScreens === void 0 ? void 0 : registryScreens.introScreen) !== null && _ref !== void 0 ? _ref : DataSyncIntroScreen;
  const resolvedSuccessScreen = (() => {
    if (successScreen) return successScreen;
    if (registryScreens !== null && registryScreens !== void 0 && registryScreens.successScreen) {
      const fn = registryScreens.successScreen;
      return props => {
        var _fn;
        return (_fn = fn(Object.assign({}, props, {
          portalId,
          trackingSource
        }))) !== null && _fn !== void 0 ? _fn : /*#__PURE__*/createElement(Fragment);
      };
    }
    return renderDefaultSuccessScreen;
  })();
  return /*#__PURE__*/_jsx(UnifiedAuthView, {
    isModal: isModal,
    isReauth: !!accountId,
    portalId: portalId,
    onComplete: account => {
      UniversalAuthTracker.track('app-management', {
        applicationId: appId,
        source: trackingSource || 'unknown',
        action: accountId ? 'APP_RECONNECTED' : 'APP_CONNECTED'
      });
      onComplete(account);
    },
    onCancel: onCancel,
    introScreen: resolvedIntroScreen,
    fetchAuthConfig: fetchAuthConfigForDataSync(portalId, appId, accountId, undefined /* don't override the hublet */),
    successScreen: resolvedSuccessScreen,
    onDuplicateAccountClick: onDuplicateAccountClick
  });
}
export default DataSyncAuthModal;